/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { cssMap as customCssMap } from '@compiled/react';

import { jsx } from '@atlaskit/css';

const wrapperStyles = customCssMap({
	icon: {
		alignItems: 'center',
		color: 'var(--nav-text-color)',
		display: 'inline-flex',
		justifyContent: 'center',
	},
	text: {
		color: 'var(--nav-text-color)',
	},
});

/**
 * Wrapper component for button text content to use CSS variable
 */
export const ButtonTextWrapper: ({ children }: { children: ReactNode }) => JSX.Element = ({
	children,
}: {
	children: ReactNode;
}) => <span css={wrapperStyles.text}>{children}</span>;

/**
 * Basic wrapper component for icons to use CSS variable for nav text color.
 * Wraps icon elements in a span that inherits the nav text color from a CSS variable.
 */
export const NavIconWrapper: ({ children }: { children: ReactNode }) => JSX.Element = ({
	children,
}: {
	children: ReactNode;
}) => <span css={wrapperStyles.icon}>{children}</span>;
